// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useCallback } from "react";
import { connect } from "react-redux";
import onClickOutside from "react-onclickoutside";

import { Options as StyeldOptions, Item } from "./styles";
import { createDirectConversation } from "src/actions/chatroom";

import type { UID } from "src/types";

type Props = {
  uid: UID,
  handleEdit: Function,
  _createDirectConversation: Function,
  handleClose: Function
};

const Options = ({
  uid,
  handleEdit,
  _createDirectConversation,
  handleClose
}: Props) => {
  Options.handleClickOutside = useCallback(() => {
    handleClose();
  }, []);

  return (
    <StyeldOptions>
      <ul>
        <Item onClick={handleEdit}>{i18n.t(k.VIEW_PROFILE)}</Item>
        <Item onClick={() => _createDirectConversation(uid)}>
          {i18n.t(k.DIRECT_MESSAGE)}
        </Item>
      </ul>
    </StyeldOptions>
  );
};

const clickOutsideConfig = {
  handleClickOutside: () => Options.handleClickOutside
};

export default connect(null, {
  _createDirectConversation: createDirectConversation
})(onClickOutside(Options, clickOutsideConfig));
